import { useThrowableSWR } from 'utils/fetcher';

import { PlsEstimatedMiles } from '../types';

export type PlsLane = {
  customerID: string;
  originZip: string;
  originCity: string;
  originState: string;
  destinationZip: string;
  destinationCity: string;
  destinationState: string;
};

// A PLS lane's estimated miles, for a per-mile rate's percent fuel surcharge. Pass no lane when
// the card doesn't need miles, so nothing is fetched (the estimate can reach Greenscreens).
export function usePlsEstimatedMiles(
  tmsID: number | undefined,
  lane: PlsLane | undefined
) {
  const key =
    tmsID && lane
      ? `load/options/pls/estimated-miles?${new URLSearchParams({
          tmsID: String(tmsID),
          customerId: lane.customerID,
          originZip: lane.originZip,
          originCity: lane.originCity,
          originState: lane.originState,
          destinationZip: lane.destinationZip,
          destinationCity: lane.destinationCity,
          destinationState: lane.destinationState,
        }).toString()}`
      : null;
  const { data, isLoading } = useThrowableSWR<PlsEstimatedMiles>(key, false);

  return { estimate: data, isLoading: Boolean(key) && isLoading };
}
